import { c as _c } from "react/compiler-runtime";
import { HospitalReviewSortEnum } from "@/entities/hospital/types/type";
import { useFeaturesHospitalStore } from "@/features/hospital/model/store";
import { useTranslations } from "next-intl";
const FilterSortingButton = () => {
  const $ = _c(20);
  const {
    selectedReviewSort,
    setSelectedReviewSort
  } = useFeaturesHospitalStore();
  const t = useTranslations();
  let t0;
  if ($[0] !== setSelectedReviewSort) {
    t0 = e => setSelectedReviewSort(e.target.value as HospitalReviewSortEnum);
    $[0] = setSelectedReviewSort;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("commonFilter.latest");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <option value={HospitalReviewSortEnum.LATEST}>{t1}</option>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("commonFilter.highScore");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <option value={HospitalReviewSortEnum.HIGH_SCORE}>{t3}</option>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("commonFilter.lowScore");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <option value={HospitalReviewSortEnum.LOW_SCORE}>{t5}</option>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== selectedReviewSort || $[15] !== t0 || $[16] !== t2 || $[17] !== t4 || $[18] !== t6) {
    t7 = <select name="review-filter" value={selectedReviewSort} onChange={t0} className="shrink-0 pr-1 text-right text-[15px] text-[#5A5C63] bg-transparent">{t2}{t4}{t6}</select>;
    $[14] = selectedReviewSort;
    $[15] = t0;
    $[16] = t2;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default FilterSortingButton;